export class rlNumericKeypad {
  constructor(options = {}) {
    // 默认选项
    this.options = {
      width: options.width || 260, // 键盘默认宽度
      height: options.height || 250, // 减小键盘默认高度
      position: options.position || { x: 0, y: 0 }, // 默认位置
      visible: options.visible || false, // 默认隐藏
      value: options.value || "", // 当前值
      maxLength: options.maxLength || 100, // 最大输入长度
      allowDecimal: options.allowDecimal !== false, // 是否允许小数点
      theme: options.theme || "light", // 主题：light或dark
      zIndex: options.zIndex || 9999, // z-index
      onConfirm: options.onConfirm || null, // 确认回调
      onCancel: options.onCancel || null, // 取消回调
      onValueChange: options.onValueChange || null, // 值变化回调
      targetElement: options.targetElement || null, // 关联的输入元素
      onRealTimeSync: options.onRealTimeSync !== false, // 是否启用实时同步
      disableLeadingZero: options.disableLeadingZero || false, // 禁止以0开头的数字（除非只有一个0）
    };

    // 私有属性
    this.keypadElement = null; // 键盘DOM元素
    this.displayElement = null; // 显示值的DOM元素
    this.confirmCallback = this.options.onConfirm; // 确认回调
    this.cancelCallback = this.options.onCancel; // 取消回调
    this.valueChangeCallback = this.options.onValueChange; // 值变化回调
    this.targetElement = this.options.targetElement; // 关联的输入元素
    this.realTimeSync = this.options.onRealTimeSync; // 是否启用实时同步
    this.outsideClickHandler = null; // 点击外部区域的处理函数
    this.cursorPosition = 0; // 添加光标位置追踪

    // 创建键盘元素
    this._createKeypadElement();

    // 如果初始可见，显示键盘
    if (this.options.visible) {
      this.show(this.options.position.x, this.options.position.y);
    }
  }

  /**
   * 创建键盘DOM元素
   * @private
   */
  _createKeypadElement() {
    const isTablet = getIsTablet();
    const height = isTablet ? 60 : 48;
    // 创建主容器
    this.keypadElement = document.createElement("div");
    this.keypadElement.className = "rl-numeric-keypad";
    this.keypadElement.style.cssText = `
      position: absolute;
      width: ${this.options.width}px;
      background-color: ${this.options.theme === "dark" ? "#333" : "#f8f8f8"};
      border: 1px solid ${this.options.theme === "dark" ? "#555" : "#ddd"};
      border-radius: 8px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
      font-family: 'Arial', sans-serif;
      display: none;
      z-index: ${this.options.zIndex};
      user-select: none;
      touch-action: manipulation;
      overflow: hidden;
    `;

    // 阻止键盘元素上的点击事件冒泡
    this.keypadElement.addEventListener("click", (e) => {
      // 阻止事件冒泡，防止触发document上的点击事件
      e.stopPropagation();

      // 检查点击的是否是可交互元素（按钮、输入框等）
      const isClickable = this._isClickableElement(e.target);
      if (!isClickable) {
        // 如果点击的不是可交互元素，关闭键盘
        this.hide();
      }
    });
    const closeContainer = document.createElement("div");
    //创建一个关闭的按钮
    const closeBtn = document.createElement("div");
    closeBtn.innerHTML = `
      <svg t="1749177169033" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4378" width="20" height="20"><path d="M631.168 332.501333a42.666667 42.666667 0 0 1 62.826667 57.621334l-2.496 2.709333-298.666667 298.666667a42.666667 42.666667 0 0 1-62.826667-57.621334l2.496-2.709333 298.666667-298.666667z" fill="#000000" p-id="4379"></path><path d="M332.501333 332.501333a42.666667 42.666667 0 0 1 57.621334-2.496l2.709333 2.496 298.666667 298.666667a42.666667 42.666667 0 0 1-57.621334 62.826667l-2.709333-2.496-298.666667-298.666667a42.666667 42.666667 0 0 1 0-60.330667z" fill="#000000" p-id="4380"></path><path d="M512 42.666667c259.2 0 469.333333 210.133333 469.333333 469.333333s-210.133333 469.333333-469.333333 469.333333S42.666667 771.2 42.666667 512 252.8 42.666667 512 42.666667z m0 74.666666C294.037333 117.333333 117.333333 294.037333 117.333333 512S294.037333 906.666667 512 906.666667 906.666667 729.962667 906.666667 512 729.962667 117.333333 512 117.333333z" fill="#000000" p-id="4381"></path></svg>
    `;
    // 移除重复的事件监听器
    // closeBtn.addEventListener("click", () => {
    //   this.hide();
    // });
    // closeBtn.addEventListener("touchend", () => {
    //   this.hide();
    // });

    // 优化关闭按钮事件监听
    closeBtn.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeBtn.style.opacity = "0.7";
      },
      { passive: false }
    );

    closeBtn.addEventListener(
      "touchend",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeBtn.style.opacity = "1";
        this.hide();
      },
      { passive: false }
    );

    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.hide();
    });
    closeContainer.style.cssText = `
      display: flex;
      justify-content: flex-end;
      padding:10px 10px 0px 10px;
    `;
    closeContainer.appendChild(closeBtn);
    this.keypadElement.appendChild(closeContainer);
    // 创建显示区域
    const displayContainer = document.createElement("div");
    displayContainer.style.cssText = `
      width: 100%;
      padding: 8px 8px 8px 12px; /* 左侧增加内边距 */
      box-sizing: border-box;
      background-color: ${this.options.theme === "dark" ? "#333" : "#f8f8f8"};
      border-bottom: 1px solid ${
        this.options.theme === "dark" ? "#444" : "#e0e0e0"
      };
      position: relative; /* 添加相对定位，以便放置关闭按钮 */
      display: flex; /* 使用flex布局 */
      align-items: center; /* 垂直居中对齐 */
      justify-content: space-between; /* 两端对齐 */
      z-index: 1; /* 确保较低的z-index，以便关闭按钮可以在上面 */
    `;

    // 创建input的容器
    const inputContainer = document.createElement("div");
    inputContainer.style.cssText = `
      flex: 1; /* 占据剩余空间 */
      margin-right: 8px; /* 减少与退格按钮的间距，使两者更贴合 */
    `;

    this.displayElement = document.createElement("input");
    this.displayElement.type = "text";
    this.displayElement.readOnly = false; // 允许聚焦和光标
    this.displayElement.inputMode = "none"; // 阻止系统键盘
    this.displayElement.value = this.options.value;
    this.displayElement.style.cssText = `
      width: 100%;
      padding: 8px;
      box-sizing: border-box;
      text-align: right;
      font-size: 18px;
      border: 1px solid ${this.options.theme === "dark" ? "#555" : "#ddd"};
      border-radius: 4px;
      background-color: ${this.options.theme === "dark" ? "#444" : "#fff"};
      color: ${this.options.theme === "dark" ? "#fff" : "#333"};
      caret-color: ${
        this.options.theme === "dark" ? "#4CAF50" : "#4CAF50"
      }; /* 添加光标颜色 */
    `;

    // 阻止键盘弹出和直接编辑
    this.displayElement.addEventListener("keydown", (e) => {
      e.preventDefault(); // 阻止默认的键盘输入
    });

    // 防止粘贴操作
    this.displayElement.addEventListener("paste", (e) => {
      e.preventDefault();
    });

    // 防止剪切操作
    this.displayElement.addEventListener("cut", (e) => {
      e.preventDefault();
    });

    // 追踪光标位置
    this.displayElement.addEventListener("click", (e) => {
      this.cursorPosition = this.displayElement.selectionStart;
    });

    // 追踪光标位置变化
    this.displayElement.addEventListener("select", (e) => {
      this.cursorPosition = this.displayElement.selectionStart;
    });

    // 手动聚焦到输入框并放置光标
    this.displayElement.addEventListener("focus", (e) => {
      // 如果是初次聚焦，光标放在末尾
      if (this.cursorPosition === undefined) {
        this.cursorPosition = this.displayElement.value.length;
      }
      this.displayElement.setSelectionRange(
        this.cursorPosition,
        this.cursorPosition
      );
    });

    // 创建右上角退格按钮（原关闭按钮）
    const closeButton = document.createElement("button");
    closeButton.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `; // 使用清晰的退格箭头SVG图标
    closeButton.style.cssText = `
      width: 50px; /* 更宽的按钮，增加可点击区域 */
      height: 40px; /* 高度与输入框匹配 */
      border-radius: 4px; /* 使用与其他按钮一致的圆角 */
      background-color: ${
        this.options.theme === "dark" ? "#444" : "#f5f5f5"
      }; /* 使用与其他按钮一致的背景色 */
      color: ${
        this.options.theme === "dark" ? "#fff" : "#333"
      }; /* 使用与其他按钮一致的文字颜色 */
      font-size: 16px;
      line-height: 1;
      text-align: center;
      cursor: pointer;
      border: 1px solid ${
        this.options.theme === "dark" ? "#555" : "#e0e0e0"
      }; /* 使用与其他按钮一致的边框 */
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0; /* 防止按钮被压缩 */
      z-index: 99999; /* 保持高z-index确保在最上层 */
      box-shadow: 0 1px 3px rgba(0,0,0,0.1); /* 简化阴影效果 */
      position: relative; /* 确保定位上下文正确 */
      transition: background-color 0.2s ease; /* 简化过渡效果 */
    `;

    // 添加简单的悬停效果
    closeButton.addEventListener("mouseenter", () => {
      closeButton.style.backgroundColor =
        this.options.theme === "dark" ? "#555" : "#e9e9e9"; // 略微深/浅一点的背景色
      closeButton.style.boxShadow = "0 2px 4px rgba(0,0,0,0.15)";
    });

    closeButton.addEventListener("mouseleave", () => {
      closeButton.style.backgroundColor =
        this.options.theme === "dark" ? "#444" : "#f5f5f5"; // 恢复原始背景色
      closeButton.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
    });

    // 使用多种事件类型来确保按钮点击有效
    // 使用命名函数，以便能够在多个事件类型中重用
    // 为右上角按钮添加退格功能
    // 添加防重复点击相关变量
    let isBackspaceCooling = false;
    const handleBackspaceClick = (e) => {
      e.preventDefault(); // 阻止默认行为
      e.stopPropagation(); // 阻止事件冒泡

      // 防止重复触发
      if (isBackspaceCooling) return false;

      // 设置冷却标志
      isBackspaceCooling = true;

      // 执行退格操作
      this._handleBackspace();

      // 100ms后重置冷却标志
      setTimeout(() => {
        isBackspaceCooling = false;
      }, 100);

      return false; // 进一步阻止默认行为
    };

    // 只保留必要的事件监听器，防止重复触发
    closeButton.addEventListener("click", handleBackspaceClick);

    // 添加touchstart事件，提高响应速度
    closeButton.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        // 添加按下效果
        closeButton.style.backgroundColor =
          this.options.theme === "dark" ? "#555" : "#e0e0e0";
        closeButton.style.boxShadow = "0 1px 2px rgba(0,0,0,0.2)";
      },
      { passive: false }
    );

    // 移动端需要的触摸事件
    closeButton.addEventListener(
      "touchend",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        // 恢复按钮样式
        closeButton.style.backgroundColor =
          this.options.theme === "dark" ? "#444" : "#f5f5f5";
        closeButton.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
        // 执行退格操作
        handleBackspaceClick(e);
      },
      { passive: false }
    );

    // 组合显示区域
    inputContainer.appendChild(this.displayElement);
    displayContainer.appendChild(inputContainer);
    displayContainer.appendChild(closeButton);
    this.keypadElement.appendChild(displayContainer);
    // 创建符号容器
    // const symbolContainer = document.createElement("div");
    // const symbolList = ["*", "-", ".", ","];
    // symbolList.forEach((symbol) => {
    //   const symbolButton = this._createButtonElement(symbol, "symbol-btn", () =>
    //     this._handleButtonClick(symbol)
    //   );
    //   symbolContainer.appendChild(symbolButton);
    // });
    // symbolContainer.style.cssText = `
    //   display: flex;
    //   flex-direction: column;
    //   gap: 6px; /* 进一步减小间距 */
    //   padding: 8px; /* 减小内边距 */
    // `;
    // 创建按钮容器
    const buttonsContainer = document.createElement("div");
    buttonsContainer.style.cssText = `
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px; /* 进一步减小间距 */
      padding: 10px; /* 减小内边距 */
    `;

    // 添加数字按钮 (1-9)
    //前面第一个都为符号，后面才是数字
    const symbolList = ["*", "-", "."];
    for (let i = 1; i <= 9; i++) {
      if ([1, 4, 7].includes(i) && symbolList.length > 0) {
        const symbol = symbolList.shift();
        const button = this._createButtonElement(symbol, "symbol-btn", () =>
          this._handleButtonClick(symbol)
        );
        buttonsContainer.appendChild(button);
      }
      const button = this._createButtonElement(i.toString(), "number-btn", () =>
        this._handleButtonClick(i.toString())
      );
      buttonsContainer.appendChild(button);
    }

    // 添加小数点按钮
    // const decimalButton = this._createButtonElement(".", "decimal-btn", () =>
    //   this._handleButtonClick(".")
    // );
    // if (!this.options.allowDecimal) {
    //   decimalButton.disabled = true;
    //   decimalButton.style.opacity = "0.5";
    // }
    // decimalButton.style.fontWeight = "bold"; // 加粗小数点，增强可见度
    // decimalButton.style.fontSize = "18px"; // 增大小数点字体

    // 添加数字0按钮
    const zeroButton = this._createButtonElement("0", "number-btn", () =>
      this._handleButtonClick("0")
    );

    // 添加清空按钮（原退格按钮）
    const backspaceButton = this._createButtonElement(
      "清除",
      "clear-all-btn",
      () => this._handleClear()
    );
    backspaceButton.style.fontWeight = "bold"; // 保持粗体以增强可见性
    backspaceButton.style.fontSize = "16px"; // 稍微大一点的字体
    backspaceButton.style.backgroundColor =
      this.options.theme === "dark" ? "#555" : "#f0f0f0";

    // // 添加逗号按钮
    const commaButton = this._createButtonElement(",", "comma-btn", () =>
      this._handleButtonClick(",")
    );
    commaButton.style.fontWeight = "bold"; // 加粗逗号，增强可见度
    commaButton.style.fontSize = "18px"; // 增大逗号字体
    // // 添加*按钮
    // const asteriskButton = this._createButtonElement("*", "asterisk-btn", () =>
    //   this._handleButtonClick("*")
    // );
    // asteriskButton.style.fontWeight = "bold"; // 加粗逗号，增强可见度
    // asteriskButton.style.fontSize = "18px"; // 增大逗号字体
    // 修改确认按钮为回车图标
    const confirmButton = this._createButtonElement("↵", "confirm-btn", () => {
      // 空函数，我们将用自定义事件处理器替代
    });
    confirmButton.style.backgroundColor = "#4CAF50";
    confirmButton.style.color = "white";
    confirmButton.style.fontSize = "20px"; /* 减小图标大小 */
    confirmButton.style.height = `${height}px`; /* 减小确认按钮高度 */
    confirmButton.style.fontWeight = "bold";
    confirmButton.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.15)"; // 减轻阴影效果

    // 为确认按钮添加特殊的事件处理，确保背景色正确恢复
    const originalBgColor = "#4CAF50"; // 保存原始背景色

    // 移除原有的事件监听器并添加新的事件处理
    confirmButton.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        confirmButton.style.backgroundColor = "#3d8b40"; // 按下时深绿色
      },
      { passive: false }
    );

    confirmButton.addEventListener(
      "touchend",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        confirmButton.style.backgroundColor = originalBgColor; // 恢复原始背景色
        this._handleConfirm();
      },
      { passive: false }
    );

    confirmButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this._handleConfirm();
      // 确保点击后背景色恢复
      setTimeout(() => {
        confirmButton.style.backgroundColor = originalBgColor;
      }, 100);
    });

    // 将"清除"按钮修改为"关闭"按钮
    // const clearButton = this._createButtonElement("×", "close-btn", () =>
    //   this.hide()
    // );
    // clearButton.style.backgroundColor = "#f44336";
    // clearButton.style.color = "white";
    // clearButton.style.fontSize = "18px"; // 增大关闭图标字体
    // clearButton.style.fontWeight = "bold";
    // clearButton.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.15)"; // 减轻阴影效果
    // clearButton.style.height = "40px"; /* 关闭按钮高度 */

    // 将底部按钮添加到容器 - 重新排序按钮
    // buttonsContainer.appendChild(decimalButton);

    buttonsContainer.appendChild(commaButton);

    buttonsContainer.appendChild(backspaceButton);
    buttonsContainer.appendChild(zeroButton);
    // buttonsContainer.appendChild(asteriskButton);
    // buttonsContainer.appendChild(clearButton);
    buttonsContainer.appendChild(confirmButton);

    this.keypadElement.appendChild(buttonsContainer);

    // 添加到文档中
    document.body.appendChild(this.keypadElement);

    // 添加拖动功能
    this._addDragFeature();
  }

  /**
   * 创建按钮元素
   * @private
   */
  _createButtonElement(text, className, clickHandler) {
    const isTablet = getIsTablet();
    const height = isTablet ? 60 : 48;
    const button = document.createElement("button");
    button.textContent = text;
    button.className = `rl-keypad-btn ${className}`;
    const defaultBgColor = this.options.theme === "dark" ? "#444" : "#f5f5f5";
    const pressedBgColor = this.options.theme === "dark" ? "#555" : "#e0e0e0";

    button.style.cssText = `
      padding: 0; /* 减小内边距 */
      font-size: 15px; /* 减小字体 */
      border: 1px solid ${this.options.theme === "dark" ? "#555" : "#e0e0e0"};
      border-radius: 4px; /* 减小圆角 */
      background-color: ${defaultBgColor};
      color: ${this.options.theme === "dark" ? "#fff" : "#333"};
      cursor: pointer;
      transition: background-color 0.2s;
      height: ${height}px; /* 减小按钮高度 */
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: normal; /* 去掉加粗 */
    `;

    // 添加touchstart事件，提高响应速度
    button.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault(); // 防止默认行为
        e.stopPropagation(); // 防止事件冒泡
        // 添加按下效果
        button.style.backgroundColor = pressedBgColor;
      },
      { passive: false }
    );

    // 保留touchend事件
    button.addEventListener(
      "touchend",
      (e) => {
        e.preventDefault(); // 防止默认行为
        e.stopPropagation(); // 防止事件冒泡
        // 恢复按钮样式
        button.style.backgroundColor = defaultBgColor;
        // 执行点击处理
        if (clickHandler) clickHandler(e);
      },
      { passive: false }
    );

    // 添加click事件，兼容桌面设备
    button.addEventListener("click", (e) => {
      // 执行点击处理
      if (clickHandler) clickHandler(e);
      // 确保点击后背景色恢复
      setTimeout(() => {
        button.style.backgroundColor = defaultBgColor;
      }, 100);
    });

    return button;
  }

  /**
   * 添加拖动功能
   * @private
   */
  _addDragFeature() {
    let isDragging = false;
    let offsetX = 0;
    let offsetY = 0;

    // 在显示区域上添加拖动事件
    const displayContainer = this.keypadElement.firstChild;

    // 找到输入容器 - 只在输入容器上添加拖动功能，避免影响关闭按钮
    const inputContainer = displayContainer.firstChild;
    if (!inputContainer) return;

    inputContainer.style.cursor = "move";

    // 修改mousedown事件，通过判断目标元素避免在关闭按钮上触发拖动
    displayContainer.addEventListener("mousedown", (e) => {
      // 如果点击的是关闭按钮或其子元素，不启动拖动
      if (
        e.target.tagName === "BUTTON" ||
        e.target.parentElement.tagName === "BUTTON"
      ) {
        return;
      }

      isDragging = true;
      offsetX = e.clientX - this.keypadElement.getBoundingClientRect().left;
      offsetY = e.clientY - this.keypadElement.getBoundingClientRect().top;
      e.preventDefault();
    });

    document.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      const x = e.clientX - offsetX;
      const y = e.clientY - offsetY;
      this.setPosition(x, y);
    });

    document.addEventListener("mouseup", () => {
      isDragging = false;
    });

    // 触摸事件支持 - 同样避免在关闭按钮上触发拖动
    displayContainer.addEventListener("touchstart", (e) => {
      // 如果触摸的是关闭按钮或其子元素，不启动拖动
      if (
        e.target.tagName === "BUTTON" ||
        e.target.parentElement.tagName === "BUTTON"
      ) {
        return;
      }

      isDragging = true;
      offsetX =
        e.touches[0].clientX - this.keypadElement.getBoundingClientRect().left;
      offsetY =
        e.touches[0].clientY - this.keypadElement.getBoundingClientRect().top;
      e.preventDefault();
    });

    document.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      const x = e.touches[0].clientX - offsetX;
      const y = e.touches[0].clientY - offsetY;
      this.setPosition(x, y);
    });

    document.addEventListener("touchend", () => {
      isDragging = false;
    });
  }

  /**
   * 处理按钮点击事件
   * @private
   */
  _handleButtonClick(value) {
    let currentValue = this.displayElement.value;
    // 获取当前光标位置
    const cursorPos = this.displayElement.selectionStart || currentValue.length;
    this.cursorPosition = cursorPos;

    // 处理小数点
    if (value === ".") {
      // 如果已经有小数点或值为空，不添加
      if (currentValue.includes(".") || currentValue === "") {
        return;
      }
    }

    // 处理逗号
    if (value === ",") {
      // 插入逗号到光标位置
      const newValue =
        currentValue.substring(0, cursorPos) +
        "," +
        currentValue.substring(cursorPos);
      this.displayElement.value = newValue;

      // 更新光标位置
      this.cursorPosition = cursorPos + 1;
      this.displayElement.setSelectionRange(
        this.cursorPosition,
        this.cursorPosition
      );

      // 同步值到目标元素
      this._syncValueToTarget();

      // 调用值变化回调
      if (this.valueChangeCallback) {
        this.valueChangeCallback(newValue);
      }

      return;
    }

    // 如果启用了禁止以0开头的选项
    if (this.options.disableLeadingZero) {
      // 如果输入的是0
      if (value === "0") {
        // 在首位输入0且值不为空，禁止输入
        if (cursorPos === 0 && currentValue !== "") {
          return;
        }
        // 如果当前值为0且光标在第一位后面，禁止继续输入0
        if (currentValue === "0" && cursorPos === 1 && value !== ".") {
          return;
        }
      }
      // 非0数字输入到首位，且当前值仅为0
      else if (currentValue === "0" && cursorPos === 1 && /[1-9]/.test(value)) {
        // 替换0而不是追加
        this.displayElement.value = value;
        this.cursorPosition = 1;
        this.displayElement.setSelectionRange(1, 1);

        // 实时同步到目标输入框（如果启用）
        this._syncValueToTarget();

        // 触发值变化回调
        if (this.valueChangeCallback) {
          this.valueChangeCallback(this.displayElement.value);
        }

        return;
      }
    }

    // 如果超过最大长度，不添加
    if (currentValue.length >= this.options.maxLength) {
      return;
    }

    // 在光标位置插入值，而不是追加到末尾
    const newValue =
      currentValue.substring(0, cursorPos) +
      value +
      currentValue.substring(cursorPos);
    this.displayElement.value = newValue;

    // 更新光标位置
    const newCursorPos = cursorPos + 1;
    this.cursorPosition = newCursorPos;
    this.displayElement.setSelectionRange(newCursorPos, newCursorPos);

    // 实时同步到目标输入框（如果启用）
    this._syncValueToTarget();

    // 如果是VXE表单，执行额外的同步措施确保第一个字符也能正确显示
    if (this.targetElement && this._isVxeInput(this.targetElement)) {
      // 再次触发VXE组件的更新
      this._forceUpdateVxeForm(this.targetElement, newValue);
    }

    // 触发值变化回调
    if (this.valueChangeCallback) {
      this.valueChangeCallback(this.displayElement.value);
    }
  }

  /**
   * 判断是否是VXE表单输入元素
   * @param {HTMLElement} element - 要判断的元素
   * @returns {boolean} - 是否是VXE输入元素
   * @private
   */
  _isVxeInput(element) {
    if (!element) return false;

    // 检查元素自身
    if (
      element.classList &&
      (element.classList.contains("vxe-input--inner") ||
        element.classList.contains("vxe-textarea--inner"))
    ) {
      return true;
    }

    // 检查父元素
    let parent = element.parentElement;
    let depth = 0;
    while (parent && depth < 3) {
      if (
        parent.classList &&
        (parent.classList.contains("vxe-input") ||
          parent.classList.contains("vxe-textarea") ||
          parent.classList.contains("vxe-form--item"))
      ) {
        return true;
      }
      parent = parent.parentElement;
      depth++;
    }

    return false;
  }

  /**
   * 强制更新VXE表单的值
   * @param {HTMLElement} element - 输入元素
   * @param {string} value - 要设置的值
   * @private
   */
  _forceUpdateVxeForm(element, value) {
    if (!element) return;

    // 找到表单项组件
    let el = element;
    let formItem = null;

    // 向上查找VXE表单项
    while (el && !formItem) {
      if (
        el.__vue__ &&
        el.__vue__.$parent &&
        el.__vue__.$parent.$options &&
        el.__vue__.$parent.$options.name === "VxeFormItem"
      ) {
        formItem = el.__vue__.$parent;
        break;
      }
      el = el.parentElement;
      if (!el) break;
    }

    // 如果找到表单项，直接操作其数据
    if (formItem && formItem.field && formItem.formData) {
      // 使用Vue提供的响应式方法设置值
      if (window.Vue && window.Vue.set) {
        window.Vue.set(formItem.formData, formItem.field, value);
      } else {
        // 回退方案
        formItem.formData[formItem.field] = value;
      }

      // 手动更新组件
      if (typeof formItem.$forceUpdate === "function") {
        formItem.$forceUpdate();
      }

      // 向上查找VXE表单并更新
      const findForm = (item) => {
        if (!item.$parent) return null;

        if (item.$parent.$options && item.$parent.$options.name === "VxeForm") {
          return item.$parent;
        }

        return findForm(item.$parent);
      };

      const form = findForm(formItem);
      if (form && typeof form.$forceUpdate === "function") {
        form.$forceUpdate();
      }
    }
  }

  /**
   * 处理退格按钮点击
   * @private
   */
  _handleBackspace() {
    let currentValue = this.displayElement.value;
    // 获取当前光标位置
    const cursorPos = this.displayElement.selectionStart || currentValue.length;
    this.cursorPosition = cursorPos;

    // 如果有选中的文本，删除选中部分
    if (
      this.displayElement.selectionStart !== this.displayElement.selectionEnd
    ) {
      const start = this.displayElement.selectionStart;
      const end = this.displayElement.selectionEnd;
      const newValue =
        currentValue.substring(0, start) + currentValue.substring(end);
      this.displayElement.value = newValue;

      // 更新光标位置
      this.cursorPosition = start;
      this.displayElement.setSelectionRange(start, start);
    }
    // 否则删除光标前的一个字符
    else if (cursorPos > 0) {
      const newValue =
        currentValue.substring(0, cursorPos - 1) +
        currentValue.substring(cursorPos);
      this.displayElement.value = newValue;

      // 更新光标位置
      const newCursorPos = cursorPos - 1;
      this.cursorPosition = newCursorPos;
      this.displayElement.setSelectionRange(newCursorPos, newCursorPos);
    }

    // 实时同步到目标输入框（如果启用）
    this._syncValueToTarget();

    // 触发值变化回调
    if (this.valueChangeCallback) {
      this.valueChangeCallback(this.displayElement.value);
    }
  }

  /**
   * 实时同步值到目标输入框
   * @private
   */
  _syncValueToTarget() {
    // 如果启用了实时同步且有目标输入元素
    if (
      this.realTimeSync &&
      this.targetElement &&
      (this.targetElement instanceof HTMLInputElement ||
        this.targetElement instanceof HTMLTextAreaElement)
    ) {
      const currentValue = this.displayElement.value;

      // 先直接设置DOM元素的值，确保基础层面的同步
      this.targetElement.value = currentValue;

      // 触发input事件，确保Vue等框架能检测到值变化
      const inputEvent = new Event("input", { bubbles: true });
      this.targetElement.dispatchEvent(inputEvent);

      // 对于Element UI组件，进行特殊处理
      this._updateElementUIValue(this.targetElement, currentValue);

      // 对于VXE组件，进行特殊处理 - 这里可能是问题所在
      // 先保证同步后，再等待一个极短的时间再次尝试VXE组件更新
      // 这样可以确保在组件内部处理完第一次更新后还能再次触发
      this._updateVxeFormValue(this.targetElement, currentValue);

      // 延迟一小段时间再次触发VXE组件更新，确保能捕获到数据变化
      setTimeout(() => {
        // 再次触发VXE组件更新，确保组件内部状态一致
        this._updateVxeFormValue(this.targetElement, currentValue);
      }, 10);

      // 触发change事件（某些组件可能需要这个事件来更新绑定值）
      const changeEvent = new Event("change", { bubbles: true });
      this.targetElement.dispatchEvent(changeEvent);
    }
  }

  /**
   * 尝试更新Element UI组件的值
   * @param {HTMLInputElement} input - 输入元素
   * @param {string} value - 新值
   * @private
   */
  _updateElementUIValue(input, value) {
    if (!input) return;

    try {
      // 查找Element UI组件容器
      let el = input;
      let elInput = null;

      // 向上查找Element UI组件
      while (el && !elInput) {
        if (
          el.classList &&
          (el.classList.contains("el-input") ||
            el.classList.contains("el-input-number"))
        ) {
          elInput = el;
          break;
        }
        el = el.parentElement;
      }

      if (elInput) {
        // 在Element UI组件上创建并分发自定义事件
        // 这会使Vue相关的绑定能够检测到值的变化
        const customEvent = new CustomEvent("el.input.change", {
          bubbles: true,
          detail: { value: value },
        });
        elInput.dispatchEvent(customEvent);

        // 针对el-input-number组件的特殊处理
        if (elInput.classList.contains("el-input-number")) {
          // 尝试触发el-input-number的内部更新
          const spinnerEvent = new CustomEvent("input.spinner", {
            bubbles: true,
            detail: { value: parseFloat(value) || 0 },
          });
          elInput.dispatchEvent(spinnerEvent);
        }

        // 如果组件内有__vue__实例（不是所有项目都会暴露这个）
        if (elInput.__vue__) {
          const vm = elInput.__vue__;
          if (typeof vm.handleInput === "function") {
            vm.handleInput(value);
          } else if (vm.$emit) {
            vm.$emit("input", value);
          }

          // 针对el-input-number的额外处理
          if (
            elInput.classList.contains("el-input-number") &&
            vm.$parent &&
            vm.$parent.handleInput
          ) {
            vm.$parent.handleInput(value);
          }
        }
      }
    } catch (e) {
      console.warn("Element UI value sync failed:", e);
    }
  }

  /**
   * 尝试更新VXE表单组件的值
   * @param {HTMLInputElement|HTMLTextAreaElement} input - 输入元素
   * @param {string} value - 新值
   * @private
   */
  _updateVxeFormValue(input, value) {
    if (!input) return;

    try {
      // 查找VXE组件容器
      let el = input;
      let vxeComponent = null;

      // 向上查找VXE组件
      while (el && !vxeComponent) {
        if (
          el.classList &&
          (el.classList.contains("vxe-input") ||
            el.classList.contains("vxe-textarea"))
        ) {
          vxeComponent = el;
          break;
        }
        el = el.parentElement;
      }

      if (vxeComponent) {
        // 直接设置input值，确保DOM状态一致
        input.value = value;

        // 1. 首先触发input事件
        const inputEvent = new Event("input", { bubbles: true });
        input.dispatchEvent(inputEvent);

        // 2. VXE组件特殊事件处理
        this._handleVxeComponentEvents(vxeComponent, value);

        // 3. 直接处理VXE表单项数据更新 - 这是关键
        this._updateVxeFormItem(vxeComponent, value);

        // 4. 分发change事件，确保组件能捕获到值变化
        const changeEvent = new Event("change", { bubbles: true });
        input.dispatchEvent(changeEvent);

        // 5. 尝试手动更新组件视图
        if (vxeComponent.__vue__) {
          const vm = vxeComponent.__vue__;
          // 强制视图刷新
          if (typeof vm.$forceUpdate === "function") {
            vm.$forceUpdate();
            // 在父组件上也强制更新
            if (vm.$parent && typeof vm.$parent.$forceUpdate === "function") {
              vm.$parent.$forceUpdate();
            }
          }
        }
      }
    } catch (e) {
      console.warn("VXE Form value sync failed:", e);
    }
  }

  /**
   * 处理VXE组件特有的事件
   * @param {HTMLElement} component - VXE组件元素
   * @param {string} value - 要设置的值
   * @private
   */
  _handleVxeComponentEvents(component, value) {
    if (!component) return;

    // VXE组件自定义事件
    const customEvent = new CustomEvent("vxe.input", {
      bubbles: true,
      detail: { value: value },
    });
    component.dispatchEvent(customEvent);

    // 查找Vue实例并更新
    if (component.__vue__) {
      const vm = component.__vue__;

      // 调用组件方法
      if (typeof vm.changeValue === "function") {
        vm.changeValue(value);
      }

      // 触发组件事件
      if (vm.$emit) {
        vm.$emit("input", value);
        vm.$emit("change", value);
        vm.$emit("update:value", value);
      }

      // 强制更新组件
      if (typeof vm.$forceUpdate === "function") {
        vm.$forceUpdate();
      }
    }
  }

  /**
   * 更新VXE表单项和表单
   * @param {HTMLElement} component - VXE组件元素
   * @param {string} value - 要设置的值
   * @private
   */
  _updateVxeFormItem(component, value) {
    if (!component || !component.__vue__) return;

    const vm = component.__vue__;

    // 查找表单项组件
    let formItem = vm.$parent;
    if (
      formItem &&
      formItem.$options &&
      formItem.$options.name === "VxeFormItem"
    ) {
      // 触发表单项事件
      if (formItem.$emit) {
        formItem.$emit("itemValue", value);
      }

      // 更新表单项数据 - 重要部分
      if (formItem.field && formItem.formData) {
        // 避免直接对属性赋值，某些情况可能无法触发更新
        let oldValue = formItem.formData[formItem.field];
        if (oldValue !== value) {
          // 使用Vue的响应式更新方法
          if (window.Vue && window.Vue.set) {
            window.Vue.set(formItem.formData, formItem.field, value);
          } else {
            // 回退方案 - 直接设置并确保触发更新
            formItem.formData[formItem.field] = value;
            // 添加额外的手动触发机制
            setTimeout(() => {
              // 创建一个临时的空对象，触发getter/setter机制
              const tmp = { ...formItem.formData };
              formItem.formData = tmp;
              // 再设置回来，进一步确保更新
              setTimeout(() => {
                formItem.formData[formItem.field] = value;
              }, 0);
            }, 0);
          }

          // 手动触发表单项更新
          if (typeof formItem.$forceUpdate === "function") {
            formItem.$forceUpdate();
          }
        }
      }

      // 查找并更新表单组件
      let formComponent = formItem.$parent;
      while (formComponent) {
        if (
          formComponent.$options &&
          formComponent.$options.name === "VxeForm"
        ) {
          // 触发表单更新事件
          if (formComponent.$emit) {
            formComponent.$emit("input", formComponent.data);
            formComponent.$emit("update:data", formComponent.data);
          }

          // 强制更新表单
          if (typeof formComponent.$forceUpdate === "function") {
            formComponent.$forceUpdate();
          }
          break;
        }
        formComponent = formComponent.$parent;
      }
    }
  }

  /**
   * 处理确认按钮点击
   * @private
   */
  _handleConfirm() {
    const value = this.displayElement.value;

    // 如果有关联的输入元素，将值填回
    if (
      this.targetElement &&
      (this.targetElement instanceof HTMLInputElement ||
        this.targetElement instanceof HTMLTextAreaElement)
    ) {
      // 这里不需要再次设置值，因为已经通过实时同步设置过了
      // 但仍然触发相关事件以确保所有监听器都能捕获到

      // 触发input事件
      const event = new Event("input", { bubbles: true });
      this.targetElement.dispatchEvent(event);

      // 触发change事件
      const changeEvent = new Event("change", { bubbles: true });
      this.targetElement.dispatchEvent(changeEvent);

      // 模拟键盘回车事件，让输入框表单提交或触发相应的回车键行为
      // 触发keydown和keyup事件，使其与真实键盘行为一致
      const keydownEvent = new KeyboardEvent("keydown", {
        key: "Enter",
        code: "Enter",
        keyCode: 13,
        which: 13,
        bubbles: true,
        cancelable: true,
      });
      this.targetElement.dispatchEvent(keydownEvent);

      // 如果keydown事件没有被阻止，则继续触发keyup和keypress
      if (!keydownEvent.defaultPrevented) {
        // 触发keypress事件
        const keypressEvent = new KeyboardEvent("keypress", {
          key: "Enter",
          code: "Enter",
          keyCode: 13,
          which: 13,
          bubbles: true,
          cancelable: true,
        });
        this.targetElement.dispatchEvent(keypressEvent);

        // 触发keyup事件
        const keyupEvent = new KeyboardEvent("keyup", {
          key: "Enter",
          code: "Enter",
          keyCode: 13,
          which: 13,
          bubbles: true,
        });
        this.targetElement.dispatchEvent(keyupEvent);
      }

      // 触发blur事件，模拟用户完成输入
      const blurEvent = new Event("blur", { bubbles: true });
      this.targetElement.dispatchEvent(blurEvent);
    }

    if (this.confirmCallback) {
      this.confirmCallback(value);
    }

    this.hide();
  }

  /**
   * 处理清除按钮点击
   * @private
   */
  _handleClear() {
    // 清空显示值
    this.displayElement.value = "";

    // 实时同步到目标输入框（如果启用）
    this._syncValueToTarget();

    // 触发值变化回调
    if (this.valueChangeCallback) {
      this.valueChangeCallback("");
    }
  }

  /**
   * 处理取消按钮点击（保留兼容性，但实际不再使用）
   * @private
   */
  _handleCancel() {
    if (this.cancelCallback) {
      this.cancelCallback();
    }
    this.hide();
  }

  /**
   * 显示键盘
   * @param {number} x - x坐标
   * @param {number} y - y坐标
   */
  show(x, y, isGrid = false) {
    if (x !== undefined && y !== undefined) {
      this.setPosition(x, y);
    }
    this.keypadElement.style.display = "block";

    // 自动清空输入框内容
    //这里添加如果是轴线才清空，否则不清
    if (isGrid) {
      this._handleClear();
    }

    // 添加点击外部区域关闭键盘的事件
    this._addOutsideClickEvent();
  }

  /**
   * 隐藏键盘
   */
  hide() {
    // this._handleConfirm()
    this.keypadElement.style.display = "none";

    // 移除点击外部区域关闭键盘的事件
    this._removeOutsideClickEvent();
  }

  /**
   * 设置键盘位置
   * @param {number} x - x坐标
   * @param {number} y - y坐标
   */
  setPosition(x, y) {
    // 确保位置在屏幕内
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const keypadWidth = this.options.width; // 使用预定义宽度，避免在隐藏状态下无法获取实际宽度
    const keypadHeight = this.options.height; // 使用预定义高度

    // 计算位置，确保不超出屏幕
    let posX = Math.max(0, Math.min(x, viewportWidth - keypadWidth - 10));
    let posY = Math.max(0, Math.min(y, viewportHeight - keypadHeight - 10));
    // 设置位置
    this.keypadElement.style.left = `${posX}px`;
    this.keypadElement.style.top = `${posY}px`;
  }

  /**
   * 获取当前输入值
   * @returns {string} - 当前输入值
   */
  getValue() {
    return this.displayElement.value;
  }

  /**
   * 设置当前输入值
   * @param {string} value - 要设置的值
   */
  setValue(value) {
    this.displayElement.value = value;
  }

  /**
   * 设置确认回调函数
   * @param {Function} callback - 回调函数
   */
  onConfirm(callback) {
    this.confirmCallback = callback;
  }

  /**
   * 设置取消回调函数
   * @param {Function} callback - 回调函数
   */
  onCancel(callback) {
    this.cancelCallback = callback;
  }

  /**
   * 设置值变化回调函数
   * @param {Function} callback - 回调函数
   */
  onValueChange(callback) {
    this.valueChangeCallback = callback;
  }

  /**
   * 设置键盘位置在元素旁边
   * @param {HTMLElement} element - 目标元素
   */
  showNextToElement(element) {
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const keypadWidth = this.options.width;
    const keypadHeight = this.options.height;

    // 计算最佳位置策略
    let bestStrategy = this._calculateBestPositionStrategy(
      rect,
      viewportWidth,
      viewportHeight,
      keypadWidth,
      keypadHeight
    );

    // 应用最佳策略
    let position = this._applyPositionStrategy(
      bestStrategy,
      rect,
      keypadWidth,
      keypadHeight
    );

    const attributes = element.attributes || [];
    let isGrid = false;
    for (let i = 0; i < attributes.length; i++) {
      if (
        attributes[i].name === "data-is-rl-grid" &&
        attributes[i].nodeValue === "true"
      ) {
        isGrid = true;
        break;
      }
    }
    this.show(position.x, position.y, isGrid);
  }

  /**
   * 计算最佳位置策略
   * @private
   */
  _calculateBestPositionStrategy(
    rect,
    viewportWidth,
    viewportHeight,
    keypadWidth,
    keypadHeight
  ) {
    // 定义不同的位置策略
    const strategies = {
      BELOW: { id: "BELOW", priority: 1 },
      ABOVE: { id: "ABOVE", priority: 2 },
      RIGHT: { id: "RIGHT", priority: 3 },
      LEFT: { id: "LEFT", priority: 4 },
    };

    // 计算每个策略的可用空间和溢出情况
    const availableSpace = {
      BELOW: viewportHeight - rect.bottom - 5,
      ABOVE: rect.top - 5,
      RIGHT: viewportWidth - rect.right - 5,
      LEFT: rect.left - 5,
    };

    const overflow = {
      BELOW: Math.max(0, keypadHeight - availableSpace.BELOW),
      ABOVE: Math.max(0, keypadHeight - availableSpace.ABOVE),
      RIGHT: Math.max(0, keypadWidth - availableSpace.RIGHT),
      LEFT: Math.max(0, keypadWidth - availableSpace.LEFT),
    };

    // 对策略进行评分和排序（溢出越少，分数越高）
    const scoredStrategies = Object.values(strategies).map((strategy) => {
      const id = strategy.id;
      // 分数基于溢出量（负分）和优先级
      const score = -overflow[id] * 100 + (5 - strategy.priority);
      return { ...strategy, score };
    });

    // 按分数排序并返回最佳策略
    scoredStrategies.sort((a, b) => b.score - a.score);
    return scoredStrategies[0].id;
  }

  /**
   * 应用位置策略
   * @private
   */
  _applyPositionStrategy(strategy, rect, keypadWidth, keypadHeight) {
    let x, y;

    switch (strategy) {
      case "BELOW":
        x = rect.left + (rect.width - keypadWidth) / 2; // 水平居中
        y = rect.bottom + 5;
        break;
      case "ABOVE":
        x = rect.left + (rect.width - keypadWidth) / 2; // 水平居中
        y = rect.top - keypadHeight - 5;
        break;
      case "RIGHT":
        x = rect.right + 5;
        y = rect.top + (rect.height - keypadHeight) / 2; // 垂直居中
        break;
      case "LEFT":
        x = rect.left - keypadWidth - 5;
        y = rect.top + (rect.height - keypadHeight) / 2; // 垂直居中
        break;
      default:
        x = rect.left;
        y = rect.bottom + 5;
    }

    return { x, y };
  }

  /**
   * 设置关联的输入元素
   * @param {HTMLInputElement|HTMLTextAreaElement} element - 输入元素
   */
  setTargetElement(element) {
    this.targetElement = element;

    // 如果元素有值，同步到显示区域
    if (
      element &&
      (element instanceof HTMLInputElement ||
        element instanceof HTMLTextAreaElement)
    ) {
      this.setValue(element.value);
    }
  }

  /**
   * 添加点击外部区域关闭键盘的事件
   * @private
   */
  _addOutsideClickEvent() {
    // 如果已有处理函数，先移除
    this._removeOutsideClickEvent();

    // 创建新的处理函数 - 点击事件
    this.outsideClickHandler = (e) => {
      // 检查是否点击在键盘外部
      if (
        this.keypadElement &&
        !this.keypadElement.contains(e.target) &&
        this.keypadElement.style.display === "block" &&
        (!this.targetElement ||
          (this.targetElement && !this.targetElement.contains(e.target)))
      ) {
        this._handleConfirm();
        // this.hide();
      }
    };
    setTimeout(() => {
      //这里用定时器是因为点击事件太快了 还没有显示出来就关闭了
      // 添加到document，使用捕获阶段（第三个参数为true）
      document.addEventListener("click", this.outsideClickHandler, true);
    }, 1000);

    // 创建新的处理函数 - 鼠标按下事件
    this.outsideMousedownHandler = (e) => {
      // 同样的逻辑，但监听mousedown事件
      if (
        this.keypadElement &&
        !this.keypadElement.contains(e.target) &&
        this.keypadElement.style.display === "block" &&
        (!this.targetElement ||
          (this.targetElement && !this.targetElement.contains(e.target)))
      ) {
        this._handleConfirm();
        // this.hide();
      }
    };

    // 添加鼠标按下事件，使用捕获阶段
    document.addEventListener("mousedown", this.outsideMousedownHandler, true);

    // 创建新的处理函数 - 触摸开始事件
    this.outsideTouchstartHandler = (e) => {
      // 同样的逻辑，但监听touchstart事件
      if (
        this.keypadElement &&
        !this.keypadElement.contains(e.target) &&
        this.keypadElement.style.display === "block" &&
        (!this.targetElement ||
          (this.targetElement && !this.targetElement.contains(e.target)))
      ) {
        this._handleConfirm();
        // this.hide();
      }
    };

    // 添加触摸开始事件，使用捕获阶段
    document.addEventListener(
      "touchstart",
      this.outsideTouchstartHandler,
      true
    );
  }

  /**
   * 移除点击外部区域关闭键盘的事件
   * @private
   */
  _removeOutsideClickEvent() {
    if (this.outsideClickHandler) {
      document.removeEventListener("click", this.outsideClickHandler, true);
      this.outsideClickHandler = null;
    }
    if (this.outsideMousedownHandler) {
      document.removeEventListener(
        "mousedown",
        this.outsideMousedownHandler,
        true
      );
      this.outsideMousedownHandler = null;
    }
    if (this.outsideTouchstartHandler) {
      document.removeEventListener(
        "touchstart",
        this.outsideTouchstartHandler,
        true
      );
      this.outsideTouchstartHandler = null;
    }
  }

  /**
   * 销毁键盘
   */
  destroy() {
    // 移除点击外部事件
    this._removeOutsideClickEvent();

    if (this.keypadElement && this.keypadElement.parentNode) {
      this.keypadElement.parentNode.removeChild(this.keypadElement);
    }
    this.keypadElement = null;
    this.displayElement = null;
  }

  /**
   * 检查元素是否为可交互元素（不应触发关闭）
   * @private
   * @param {HTMLElement} element - 要检查的元素
   * @returns {boolean} - 如果是可交互元素则返回true
   */
  _isClickableElement(element) {
    if (!element) return false;

    // 检查是否是按钮
    if (
      element.tagName === "BUTTON" ||
      element.classList.contains("rl-keypad-btn")
    ) {
      return true;
    }

    // 检查是否是输入框
    if (element === this.displayElement) {
      return true;
    }

    // 检查是否是拖拽区域
    const displayContainer = this.keypadElement.firstChild;
    const inputContainer = displayContainer
      ? displayContainer.firstChild
      : null;
    if (element === inputContainer) {
      return true;
    }

    // 检查父元素是否是按钮或输入框（处理SVG图标等子元素）
    let parent = element.parentElement;
    while (parent && parent !== this.keypadElement) {
      if (
        parent.tagName === "BUTTON" ||
        parent.classList.contains("rl-keypad-btn") ||
        parent === this.displayElement ||
        parent === inputContainer
      ) {
        return true;
      }
      parent = parent.parentElement;
    }

    return false;
  }
}

function getIsTablet() {
  // 获取用户代理字符串并转换为小写
  const userAgent = navigator.userAgent.toLowerCase();
  // 获取屏幕宽度
  const screenWidth = window.screen.width;
  // 获取屏幕高度
  const screenHeight = window.screen.height;
  // 计算屏幕对角线尺寸（以英寸为单位）
  const screenSize =
    Math.sqrt(
      Math.pow(screenWidth / window.devicePixelRatio, 2) +
        Math.pow(screenHeight / window.devicePixelRatio, 2)
    ) / 96;

  // 检查是否包含常见平板设备的关键字
  const hasTabletKeywords =
    userAgent.includes("tablet") ||
    userAgent.includes("ipad") ||
    (userAgent.includes("android") && !userAgent.includes("mobile")) ||
    (userAgent.includes("firefox") && userAgent.includes("tablet")) ||
    userAgent.includes("kindle") ||
    userAgent.includes("silk");

  // 结合屏幕尺寸和关键字进行判断
  return hasTabletKeywords || (screenSize >= 6 && screenSize <= 13);
}
